import { inject as service } from '@ember/service';
import Component from '@ember/component';
import { IN_REACT_NATIVE, EVENTS } from '../constants/environment';

/**
 * In the context of React Native, device data is injected into the web application. While the user
 * is logged in, there is also a mechanism that emits events via script injection whenever the
 * Firebase Cloud Messaging (FCM) token is set. At this point, all the data is gathered in order to
 * make a API call that associates the device with the current user.
 */
export default Component.extend({
  tagName: '',

  errorTracker: service('error-tracker'),
  userCommandService: service('commands/user-commands'),
  session: service(),

  handleTokenChange(event) {
    const user = this.get('session.currentUser');
    const fcmToken = event.detail;
    const deviceData = window.SH_DEVICE_DATA;

    this.get('userCommandService').registerDevice(user, fcmToken, deviceData)
      .catch((error) => {
        console.error(error);
        const userID = user.get('id');
        const description = `Failed to register device ${deviceData.deviceID} for user ${userID}`;
        this.get('errorTracker').error(description, this);
      });
  },

  init() {
    this._super(...arguments);

    if (!IN_REACT_NATIVE) return;

    this.handleTokenChangeBound = this.handleTokenChange.bind(this);

    document.addEventListener(EVENTS.FCM_TOKEN_CHANGED, this.handleTokenChangeBound);

    // Notify React Native that the user is logged in and pass along the cookies.
    window.ReactNativeWebView.postMessage(`{
      "type": "${EVENTS.USER_LOGGED_IN}",
      "payload": "${document.cookie}"
    }`);
  },

  willDestroyElement() {
    this._super(...arguments);

    if (!IN_REACT_NATIVE) return;

    document.removeEventListener(EVENTS.FCM_TOKEN_CHANGED, this.handleTokenChangeBound);
  },
});
